import React from 'react';
import { SearchResultItemContainer } from './styles';
import {
  renderAsHeading,
  renderMarkdown,
} from '../../../Section/features/ContentFeature/overrides/markdown';
import { QsgSearchResult } from '../../../../fetch-data/graphql';
import { BreadcrumbsList } from './BreadcrumList';
import { cleanPlaintext, highlightSearchTerm } from './helpers';
import { FeatureAppTrackingManager } from '../../../../typings/tagging';
import { VehicleModel } from '../../../../fetch-data/graphql/types';
import { onVWBasicLinkClickEvent_SearchResult } from '../../../../tagging/tagging-helpers';
import { totalmem } from 'os';

interface SearchResultItemProps {
  result: QsgSearchResult;
  onSelect: (sectionId: string, searchTerm: string, result: any, resultRelativeIndex: any, totalResults: any) => void;
  isMobile: boolean;
  searchTerm: string;
  trackingManager: FeatureAppTrackingManager;
  resultRelativeIndex: number;
  totalResults: number;
  model?: VehicleModel;
}

export const SearchResultItem = ({
  result,
  onSelect,
  isMobile,
  searchTerm,
  trackingManager,
  resultRelativeIndex,
  totalResults,
  model,
}: SearchResultItemProps) => {
  const { resultTitle, resultContent } = result;

  const cleanedTitle = resultTitle.plaintext
    ? cleanPlaintext(resultTitle.plaintext)
    : '';
  const highlightedTitle = cleanedTitle
    ? highlightSearchTerm(cleanedTitle, searchTerm)
    : '';
  const title = highlightedTitle
    ? '<p>' + highlightedTitle + '</p>'
    : '<p></p>';

  const cleanedContent = resultContent.trimmed
    ? cleanPlaintext(resultContent.trimmed)
    : '';
  const highlightedContent = cleanedContent
    ? highlightSearchTerm(cleanedContent, searchTerm)
    : '';
  const content = highlightedContent
    ? '<p>' + highlightedContent + '</p>'
    : '<p></p>';

  return (
    <SearchResultItemContainer
      onClick={() => {
        onSelect(result.sectionId, searchTerm, result, resultRelativeIndex, totalResults);
      }}
    >
      <BreadcrumbsList chain={result.chain} isMobile={isMobile} />
      {renderAsHeading({
        text: title,
        level: 4,
        forceHeading: true,
        isPreview: true,
      })}
      {renderMarkdown({ text: content, isPreview: true })}
    </SearchResultItemContainer>
  );
};
